import { useMemo } from 'react';

import { Grid } from '@react-three/drei';
import { useAtomValue } from 'jotai';

import { currentFrameAtom } from '@store';
import { colors } from '@ui';

import { CameraControls } from './CameraControls';
import { CanvasScene } from './CanvasScene';
import { useElvaVisualizerContext } from './ElvaVisualizerContext';
import { Gizmo } from './Gizmo';
import { parseFocusId } from './helpers';
import { SceneComposition } from './SceneComposition';

import type { ElvaVisualizerProps } from './types';

export const ElvaVisualizer = (props: ElvaVisualizerProps) => {
    const { freezePosition, comparisonFrame, overlayComparison = false }: ElvaVisualizerProps = props;
    const { currentFocusId } = useElvaVisualizerContext();
    const currentFocus = useMemo(() => parseFocusId(currentFocusId), [currentFocusId]);
    const currentFrame = useAtomValue(currentFrameAtom);

    return (
        <CanvasScene>
            <CameraControls {...props} />
            <SceneComposition
                currentFrame={currentFrame}
                currentFocus={currentFocus}
                freezePosition={freezePosition}
                comparisonFrame={comparisonFrame}
                overlayComparison={overlayComparison}
            />
            <Gizmo />
            <Grid
                infiniteGrid
                fadeFrom={0}
                fadeStrength={2}
                fadeDistance={30}
                cellThickness={1}
                cellSize={0.25}
                cellColor={colors.bluegray[200]}
                sectionColor={colors.bluegray[200]}
            />
        </CanvasScene>
    );
};

export default ElvaVisualizer;
